import { FlagAt, FlagCh, FlagDe, FlagIt } from '@packages/themes/icons';
import type { GeoCountryFlagType } from './types';

export const GeoCountryFlag = ({ flag }: GeoCountryFlagType) => {
  switch (flag) {
    case 'at':
      return <FlagAt />;
    case 'de':
      return <FlagDe />;
    case 'ch':
      return <FlagCh />;
    case 'it':
      return <FlagIt />;
    default:
      return null;
  }
};
